module.exports = __webpack_public_path__ + "img/bag.73c57cb5.svg";